import type { IconProps } from "./types";

export function List({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
        ? color
        : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.5 5.09961C20.9971 5.09961 21.4004 5.50294 21.4004 6C21.4004 6.49706 20.9971 6.90039 20.5 6.90039H7.5C7.00294 6.90039 6.59961 6.49706 6.59961 6C6.59961 5.50294 7.00294 5.09961 7.5 5.09961H20.5Z"
        fill={currentColor}
      />
      <path
        d="M20.5 11.0996C20.9971 11.0996 21.4004 11.5029 21.4004 12C21.4004 12.4971 20.9971 12.9004 20.5 12.9004H7.5C7.00294 12.9004 6.59961 12.4971 6.59961 12C6.59961 11.5029 7.00294 11.0996 7.5 11.0996H20.5Z"
        fill={currentColor}
      />
      <path
        d="M20.5 17.0996C20.9971 17.0996 21.4004 17.5029 21.4004 18C21.4004 18.4971 20.9971 18.9004 20.5 18.9004H7.5C7.00294 18.9004 6.59961 18.4971 6.59961 18C6.59961 17.5029 7.00294 17.0996 7.5 17.0996H20.5Z"
        fill={currentColor}
      />
      <path
        d="M3.50977 5.09961C4.00682 5.09961 4.41016 5.50294 4.41016 6C4.41016 6.49706 4.00682 6.90039 3.50977 6.90039H3.5C3.00294 6.90039 2.59961 6.49706 2.59961 6C2.59961 5.50294 3.00294 5.09961 3.5 5.09961H3.50977Z"
        fill={currentColor}
      />
      <path
        d="M3.50977 11.0996C4.00682 11.0996 4.41016 11.5029 4.41016 12C4.41016 12.4971 4.00682 12.9004 3.50977 12.9004H3.5C3.00294 12.9004 2.59961 12.4971 2.59961 12C2.59961 11.5029 3.00294 11.0996 3.5 11.0996H3.50977Z"
        fill={currentColor}
      />
      <path
        d="M3.50977 17.0996C4.00682 17.0996 4.41016 17.5029 4.41016 18C4.41016 18.4971 4.00682 18.9004 3.50977 18.9004H3.5C3.00294 18.9004 2.59961 18.4971 2.59961 18C2.59961 17.5029 3.00294 17.0996 3.5 17.0996H3.50977Z"
        fill={currentColor}
      />
    </svg>
  );
}
